import styled from 'styled-components';
import { up, down, between, only } from 'styled-breakpoints';
import { css } from 'styled-components'

const baseHeadings = css`
  color: ${props => props.colorFont || props.theme.color.base};
  font-family: ${props => props.fontFamily || props.theme.font.header};
  text-transform: ${props => props.textTransform};
  text-align: ${props => props.textAlign};
  padding-bottom: ${props => props.pb};
  padding-top: ${props => props.pt};
  padding-left: ${props => props.pl};
  padding-right: ${props => props.pr};
  margin-bottom: ${props => props.mb};
  margin-top: ${props => props.mt};
  margin-left: ${props => props.ml};
  margin-right: ${props => props.mr};
`;

export const Text = styled.p`
  color: ${props => props.colorFont || props.theme.color.font};
  font-family: ${props => props.fontFamily || props.theme.font.main};
  text-transform: ${props => props.textTransform};
  font-weight: ${props => props.weight || props.theme.font.weight};

  ${up('xl')} {
    font-size: ${props => props.xl || props.theme.font.size.p.xl};
    line-height: ${props => props.lineHeight || 1.7};
  }

  ${down('lg')} {
    font-size: ${props => props.l || props.theme.font.size.p.l};
    line-height: ${props => props.lineHeight || 1.6};
  }

  ${down('md')} {
    font-size: ${props => props.m || props.theme.font.size.p.m};
    line-height: ${props => props.lineHeight || 1.5};
  }

  ${down('sm')} {
    font-size: ${props => props.s || props.theme.font.size.p.s};
    line-height: ${props => props.lineHeight || '1,5'};
  }

  ${down('xs')} {
    font-size: ${props => props.xs || props.theme.font.size.p.xs};
    line-height: ${props => props.lineHeight || '1,5'};
  }
`;

export const H6 = styled.h6`
  ${baseHeadings}

  ${up('xl')} {
    font-size: ${props => props.xl || props.theme.font.size.p.xl};
    line-height: ${props => props.lineHeight || 1.7};
  }

  ${down('lg')} {
    font-size: ${props => props.l || props.theme.font.size.p.l};
    line-height: ${props => props.lineHeight || 1.6};
  }

  ${down('md')} {
    font-size: ${props => props.m || props.theme.font.size.p.m};
    line-height: ${props => props.lineHeight || 1.5};
  }

  ${down('sm')} {
    font-size: ${props => props.s || props.theme.font.size.p.s};
    line-height: ${props => props.lineHeight || '1,5'};
  }

  ${down('xs')} {
    font-size: ${props => props.xs || props.theme.font.size.p.xs};
    line-height: ${props => props.lineHeight || '1,5'};
  }
`;

export const H5 = styled.h5`
  ${baseHeadings}

  ${up('xl')} {
    font-size: ${props => props.xl || props.theme.font.size.h5.xl};
    line-height: ${props => props.lineHeight || 1.7};
  }

  ${down('lg')} {
    font-size: ${props => props.l || props.theme.font.size.h5.l};
    line-height: ${props => props.lineHeight || 1.6};
  }

  ${down('md')} {
    font-size: ${props => props.m || props.theme.font.size.h5.m};
    line-height: ${props => props.lineHeight || 1.5};
  }

  ${down('sm')} {
    font-size: ${props => props.s || props.theme.font.size.h5.s};
    line-height: ${props => props.lineHeight || '1,5'};
  }

  ${down('xs')} {
    font-size: ${props => props.xs || props.theme.font.size.h5.xs};
    line-height: ${props => props.lineHeight || '1,5'};
  }
`;

export const H3 = styled.h3`
  ${baseHeadings}

  ${up('xl')} {
    font-size: ${props => props.xl || props.theme.font.size.h3.xl};
    line-height: ${props => props.lineHeight || 1.7};
  }

  ${down('lg')} {
    font-size: ${props => props.l || props.theme.font.size.h3.l};
    line-height: ${props => props.lineHeight || 1.6};
  }

  ${down('md')} {
    font-size: ${props => props.m || props.theme.font.size.h3.m};
    line-height: ${props => props.lineHeight || 1.5};
  }

  ${down('sm')} {
    font-size: ${props => props.s || props.theme.font.size.h3.s};
    line-height: ${props => props.lineHeight || '1,5'};
  }

  ${down('xs')} {
    font-size: ${props => props.xs || props.theme.font.size.h3.xs};
    line-height: ${props => props.lineHeight || '1,5'};
  }
`;

export const H2 = styled.h2`
  ${baseHeadings}

  ${up('xl')} {
    font-size: ${props => props.xl || props.theme.font.size.h5.xl};
    line-height: ${props => props.lineHeight || 1.7};
  }

  ${down('lg')} {
    font-size: ${props => props.l || props.theme.font.size.h5.l};
    line-height: ${props => props.lineHeight || 1.6};
  }

  ${down('md')} {
    font-size: ${props => props.m || props.theme.font.size.h5.m};
    line-height: ${props => props.lineHeight || 1.5};
  }

  ${down('sm')} {
    font-size: ${props => props.s || props.theme.font.size.h5.s};
    line-height: ${props => props.lineHeight || '1,5'};
  }

  ${down('xs')} {
    font-size: ${props => props.xs || props.theme.font.size.h5.xs};
    line-height: ${props => props.lineHeight || '1,5'};
  }
`;

export const H1 = styled.h1`
  ${baseHeadings}

  ${up('xl')} {
    font-size: ${props => props.xl || props.theme.font.size.h1.xl};
    line-height: ${props => props.lineHeight || 1.7};
  }

  ${down('lg')} {
    font-size: ${props => props.l || props.theme.font.size.h1.l};
    line-height: ${props => props.lineHeight || 1.6};
  }

  ${down('md')} {
    font-size: ${props => props.m || props.theme.font.size.h1.m};
    line-height: ${props => props.lineHeight || 1.5};
  }

  ${down('sm')} {
    font-size: ${props => props.s || props.theme.font.size.h1.s};
    line-height: ${props => props.lineHeight || '1,5'};
  }

  ${down('xs')} {
    font-size: ${props => props.xs || props.theme.font.size.h1.xs};
    line-height: ${props => props.lineHeight || '1,5'};
  }
`;

export const TextHtml = styled.div`
  
  && p {
    white-space: pre-wrap;
    color: ${props => props.colorFont || props.theme.color.font};
    font-family: ${props => props.fontFamily || props.theme.font.main};

    ${up('xl')} {
        font-size: ${props => props.xl || props.theme.font.size.p.xl};
        line-height: ${props => props.lineHeight || 1.7};
    }

    ${down('lg')} {
        font-size: ${props => props.l || props.theme.font.size.p.l};
        line-height: ${props => props.lineHeight || 1.6};
    }

    ${down('md')} {
        font-size: ${props => props.m || props.theme.font.size.p.m};
        line-height: ${props => props.lineHeight || 1.5};
    }

    ${down('sm')} {
        font-size: ${props => props.s || props.theme.font.size.p.s};
        line-height: ${props => props.lineHeight || '1,5'};
    }

    ${down('xs')} {
        font-size: ${props => props.xs || props.theme.font.size.p.xs};
        line-height: ${props => props.lineHeight || '1,5'};
    }
  }
`;

export const Label = styled.p`
  color: ${props => props.colorFont || props.theme.color.base};
  font-family: ${props => props.fontFamily || props.theme.font.main};
  text-transform: ${props => props.textTransform || 'uppercase'};
  font-weight: ${props => props.weight || props.theme.font.weightB};

  ${up('xl')} {
    font-size: ${props => props.xl || props.theme.font.size.l.xl};
    line-height: ${props => props.lineHeight || 1.7};
  }

  ${down('lg')} {
    font-size: ${props => props.l || props.theme.font.size.l.l};
    line-height: ${props => props.lineHeight || 1.6};
  }

  ${down('md')} {
    font-size: ${props => props.m || props.theme.font.size.l.m};
    line-height: ${props => props.lineHeight || 1.5};
  }

  ${down('sm')} {
    font-size: ${props => props.s || props.theme.font.size.l.s};
    line-height: ${props => props.lineHeight || '1,5'};
  }

  ${down('xs')} {
    font-size: ${props => props.xs || props.theme.font.size.l.xs};
    line-height: ${props => props.lineHeight || '1,5'};
  }
`;